export default "__VITE_ASSET__sM8hR1jI__"